import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

import { VIRTUAL_PURIFY_CONFIG } from 'common/constants/virtualEvent';

import RawEmbed from './RawEmbed';

export default function CustomEmbed({ embedCode }) {
    const sanitizedEmbedCode = DOMPurify.sanitize(embedCode, VIRTUAL_PURIFY_CONFIG);

    return <RawEmbed embedCode={sanitizedEmbedCode} />;
}

CustomEmbed.propTypes = {
    embedCode: PropTypes.string.isRequired,
};
